import { MarkerListModel } from '@/models/marker/marker-list';
import { markersAPI } from '@/providers/apis/markers/markers';
import { Vue, Component, Prop } from 'vue-property-decorator';
import MarkerCardComponent from '../marker-card/marker-card';
import { formatTime } from '@/utils/date';

@Component({
    name: 'marker-list-panel',
    components: {
        'marker-card-panel': MarkerCardComponent,
    },
})

export default class MarkerListPanelComponent extends Vue {

    // ------------------------------------------------------
    // Properties

    private isExpanded: boolean = false;

    private activeMarker: any = null;

    @Prop()
    private markerList!: MarkerListModel[];

    private searchTerms: string = '';

    // ------------------------------------------------------
    // Hooks

    // ------------------------------------------------------
    // Actions

    private onShowRouteInfo(marker: any) {
        this.isExpanded = true;
        this.activeMarker = marker;
        (this.$refs.viewPanel as HTMLElement).scrollTop = 0;
        this.$emit('onShowRouteInfo', marker);
    }

    private onGenerateRoute() {
        this.$emit('onGenerateRoute', this.activeMarker);
    }

    private onSelectRoute(marker: any) {
        this.isExpanded = true;
        this.activeMarker = marker;
        (this.$refs.viewPanel as HTMLElement).scrollTop = 0;
        this.$emit('onGenerateRoute', this.activeMarker);
    }

    private onCloseRoute() {
        this.activeMarker = null;
        this.isExpanded = false;
        this.$emit('onCloseMarker');
    }

    private onSearchMarker() {
        this.$emit('onSearchMarker', this.searchTerms);
    }

    private onGoBack() {
        this.$emit('onGoBack');
    }

    // ------------------------------------------------------
    // Methods

    private formatTime(value: number = 0) {
        return formatTime(value);
    }





}
